import { Stack } from '../../../shared/ui/Stack/Stack';
import { Text } from '../../../shared/ui/Text/Text';
import styles from './Team.module.scss';
import photoVer from '../../../shared/assets/photo/Team/V_1x.png';
import photoVer_2x from '../../../shared/assets/photo/Team/V_2x.png';
import photoMoch from '../../../shared/assets/photo/Team/M_1x.png';
import photoMoch_2x from '../../../shared/assets/photo/Team/M_2x.png';
import Benefits from '../../Benefits/ui/Benefits';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';


gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger); 

const Team = () => {

    useGSAP(() => {
        gsap.fromTo(".team__title", {"--opacity": 0,  "--x1": "-30px",  "--x2": "30px" }, 
                                    {"--opacity": 1, "--x1": "0px",  "--x2": "0px",  
                                    duration: 3, 
                                    scrollTrigger: {
                                        trigger: ".team__title"
        }});
        gsap.fromTo(".photoVer", {opacity: 0,}, 
            {opacity: 1,   
            duration: 3, 
            border: '1px solid #30AFB8',
            scrollTrigger: {
                trigger: ".photoVer"
        }});
        gsap.fromTo(".photoMoch", {opacity: 0,}, 
            {opacity: 1,   
            duration: 3, 
            delay:2,
            border: '1px solid #30AFB8',
            scrollTrigger: {
                trigger: ".photoMoch"
        }});
    }, [])

    return ( 
        <div>
            <Stack                         
                justifyContent = 'justifyCenter' 
                alignItems = 'alignCenter'                         
                className={styles.container}                  
            >
                <Text size='xxl' className={`team__title ${styles.title}`}>
                    познакомьтесь с нашими врачами 
                </Text>    
            </Stack>

                <div  className={styles.dark}>  
                    <Stack 
                        justifyContent='justifyBetween'
                        alignItems ='alignCenter'
                        gap = '32'
                        className={styles.container}
                        
                    >
                        <Stack
                            direction = 'column'
                            gap = '16'
                            justifyContent='justifyStart'
                            alignItems ='alignCenter'
                            className={styles.content}
                        >   
                                <Text                             
                                    size ='xl'
                                    className={styles.textTitle}>
                                        Верюжский Андрей Александрович                         
                                </Text>                       
                                <Text                             
                                    size ='m'
                                    className={styles.par}>                       
                                        Врач терапевт-ортопед                         
                                </Text>

                                <Text                             
                                    className={styles.text}>  
                                        Основатель и директор клиники Iterclinic. <br/>             
                                        в 2006 году окончил Воронежскую государственную медицинскую академию.
                                </Text>
                                <Text                             
                                    className={styles.text}>
                                        Доктор проводит первичную консультацию, со всеми необходимыми обследованиями
                                        и составляет комплексный план лечения.<br/> 
                                        Лечение проводится по современным протоколам с использованием зубосохраняющих практик.
                                </Text>
                                <Text                             
                                    className={styles.text}>                                   
                                        Специализируется на эстетическом протезировании и восстановлении функции зубов всеми видами 
                                        ортопедических конструкций: коронки, виниры, бюгельные протезы. Протезирует с опорой на 
                                        собственные зубы и на имплантаты.   
                                </Text>
                                <Text                             
                                    className={styles.text}>
                                        Доктор предоставляет качественную стоматологическую помощь всем своим пациентам 
                                        и поддерживает их спокойствие во время лечения.                                       
                                </Text>
                        </Stack>

                        <div className={styles.imgContainer}>
                            <img className={`photoVer ${styles.picture}`} src={photoVer}
                                    srcSet={`${photoVer_2x} 2x`} alt="Верюжский" />
                        </div>
                    </Stack>
                </div>

                <div  className={styles.dark}>  
                    <Stack 
                        justifyContent='justifyBetween'
                        alignItems ='alignCenter'
                        gap = '32'
                        className={styles.container__rev}
                        
                    >
                        <div className={styles.imgContainer}>
                            <img className={`photoMoch ${styles.picture}`} src={photoMoch}
                                    srcSet={`${photoMoch_2x} 2x`} alt="Мочалов" />
                        </div>

                        <Stack
                            direction = 'column'
                            gap = '16'
                            justifyContent='justifyStart'
                            alignItems ='alignCenter'
                            className={styles.content}
                        >   
                                <Text                             
                                    size ='xl'
                                    className={styles.textTitle}>
                                        Мочалов Денис Константинович                        
                                </Text>                       
                                <Text                             
                                    size ='m'
                                    className={styles.par}>                       
                                        Врач хирург-имплантолог                           
                                </Text>

                                <Text                             
                                    className={styles.text}>               
                                        в 2016 году окончил Кубанский государственный медицинский университет.
                                </Text>
                                <Text                            
                                    className={styles.text}>
                                        Специализируется на удалении зубов любой сложности, в том числе зубов мудрости.
                                        Проводит имплантацию различными системами, костную пластику, синус-лифтинг.
                                        В своей практике использует современные методы диагностики и лечения.
                                </Text>
                                <Text                            
                                    className={styles.text}>
                                        Доктор обеспечивает комфортное лечение пациентов при качественной местной анестезии. 
                                </Text>
                        </Stack>                        
                    </Stack>
                </div>

                <Benefits/>
        </div>
    );
}
export default Team;